import { ICategory } from 'us.collection.case/interfaces'

export function SaveReasons(this: any, categories: Array<ICategory>) {
    const { category, reasonSearch } = this
    return {
        categoryId: category,
        reasonName: `${categories.find((item: ICategory) => item.categoryID === category)?.categoryName}_${reasonSearch}`
    }
}
